export const mutations = {
  CLEAR_INTERESTS(state) {
    localStorage.removeItem('interests');
    state.interests = {
      indications: [],
      therapeuticAreas: [],
      drugClasses: [],
      devPhase: [],
      currObjectives: [],
    };
  },
};
